export default function authHeader() {
  const raw = localStorage.getItem("user");
  let token = null;
  try {
    const parsed = JSON.parse(raw);
    token = parsed?.token || parsed?.accessToken || parsed?.access_token || parsed;
  } catch {
    token = raw;
  }
  const normalizedToken = String(token || "")
    .trim()
    .replace(/^Bearer\s+/i, "")
    .replace(/^"+|"+$/g, "");
  return normalizedToken ? { Authorization: `Bearer ${normalizedToken}` } : {};
}
